// @flow
import type {
  Action,
} from 'fc-flow-types/redux'

import {
  MIGRATE_ASSET,
  SUBMIT_MIGRATE_ASSET,
} from './constants'

export function migrateAsset (): Action<> {
  return {
    type: MIGRATE_ASSET,
  }
}

export function submitMigrateAsset (): Action<> {
  return {
    type: SUBMIT_MIGRATE_ASSET,
  }
}

export default {
  migrateAsset,
  submitMigrateAsset,
}
